 
import React, { lazy, Suspense, useEffect, useState, useRef } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import posthog from 'posthog-js';
import { LifeBuoy } from 'lucide-react';
import {getAllcourseDetails,getCourseCompletion,getSatDetails,getOfferbaner,getNEETAssessment} from '../../../../Redux/Action';
import {ComingFrom} from '../../../../store/reducer';
import ProfileView from '../../../profile/Index';
import SupportDrawer from '../../../../components/SupportDrawer';
import lazyRetry from '../../../../utils/lazyUtils'
// const DashboardView = lazy(() => import('./components/DashboardView'));
// const CoursesView = lazy(() => import('./components/CoursesView'));
// const AssessmentsView = lazy(() => import('./components/AssessmentsView'));


const DashboardView = lazy(() =>
  lazyRetry(() => import('./components/DashboardView'))
);

const CoursesView = lazy(() =>
  lazyRetry(() => import('./components/CoursesView'))
);

const AssessmentsView = lazy(() =>
  lazyRetry(() => import('./components/AssessmentsView'))
);

const EBooksView = lazy(() =>
  lazyRetry(() => import('./components/EbooksView'))
);

const DashboardIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);
 
const CoursesIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);
 
const TestSeriesIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" />
    <path d="M9 12h6M9 16h4" />
  </svg>
);

const EbookIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const SettingsIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
 
const NAV_ITEMS = [
  { label: 'Dashboard', icon: DashboardIcon, view: 'Dashboard' },
  { label: 'Test Series', icon: TestSeriesIcon, view: 'Assessments' },
  { label: 'Courses',   icon: CoursesIcon,   view: 'Courses'   },
  // { label: 'E-Books',   icon: EbookIcon,     view: 'EBooks'    },
   ...(process.env.REACT_APP_ENV === 'dev' ? [{label: 'E-Books',   icon: EbookIcon,     view: 'EBooks'  }]: []),
  { label: 'Profile', icon: SettingsIcon,   view: 'Profile'  },
  { label: 'Support', icon: LifeBuoy, view: 'Support', isSupport: true },
];
 
const ASSESSMENT_VIEWS = ['Assessments', 'General Assessment', 'NEET Assessment', 'SAT/ACT'];
 
const isNavActive = (item, activeView) => {
  if (item.view === 'Assessments') return ASSESSMENT_VIEWS.includes(activeView);
  return activeView === item.view;
};

const Sidebar = ({ activeView, onNavigate, onOpenSupport }) => (
  <aside style={sidebarStyles.sidebar}>
    <div style={sidebarStyles.logoWrap}>
      <div style={sidebarStyles.logoMark} />
    </div>
    <nav style={sidebarStyles.nav}>
      {NAV_ITEMS.map((item) => {
        const active = isNavActive(item, activeView);
        const Icon = item.icon;
        return (
          <button
            key={item.view}
            onClick={() => (item.isSupport ? onOpenSupport() : onNavigate(item.view))}
            style={{
              ...sidebarStyles.navItem,
              ...(active ? sidebarStyles.navItemActive : {}),
            }}
          >
            <span style={{ ...sidebarStyles.navIcon, color: active ? '#2563eb' : '#6b7280' }}>
              <Icon size={18} />
            </span>
            <span style={{
              ...sidebarStyles.navLabel,
              color: active ? '#111827' : '#374151',
              fontWeight: active ? 600 : 400,
            }}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  </aside>
);

const BottomNav = ({ activeView, onNavigate, onOpenSupport }) => (
  <nav style={bottomNavStyles.nav}>
    {NAV_ITEMS.map((item) => {
      const active = isNavActive(item, activeView);
      const Icon = item.icon;
      return (
        <button
          key={item.view}
          onClick={() => (item.isSupport ? onOpenSupport() : onNavigate(item.view))}
          style={bottomNavStyles.item}
        >
          <span style={{ color: active ? '#2563eb' : '#9ca3af', transition: 'color 0.15s' }}>
            <Icon size={22} />
          </span>
          <span style={{
            ...bottomNavStyles.label,
            color: active ? '#2563eb' : '#9ca3af',
            fontWeight: active ? 600 : 400,
          }}>
            {item.label}
          </span>
          {active && <span style={bottomNavStyles.activeDot} />}
        </button>
      );
    })}
  </nav>
);
 
const DashboardSkeleton = () => (
  <div style={{ minHeight: '100vh', background: '#f9fafb' }} />
);
 
const LoadingFallback = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
    <CircularProgress size={50} />
  </Box>
);
 
const OptimizedDashboard = () => {
  const dispatch = useDispatch();
  const location = useLocation()
  const [searchParams] = useSearchParams();
  // const cardview = useSelector((state) => state?.comingfrom || 'Dashboard');
  const cardview = (useSelector((state) => state?.comingfrom || 'Dashboard'))?.replace(/^"|"$/g, '');
  const userInfo  = useSelector((state) => state.userInfo);
  const details = useSelector((state) => state.onboardinfo)  
  const [isLoading, setIsLoading] = useState(false); 
  const scrollRef = useRef(null);
  const maxScrollDepthRef = useRef(0); 
   
 
const getInitialViewFromPreference = (details) => {
  const preferences = details?.learningtypepreference;
 
  if (!preferences?.length) return cardview;
 
  const firstPreference = preferences.reduce((min, curr) =>
    curr.selectionOrder < min.selectionOrder ? curr : min
  );
 
  switch (firstPreference.type) {
    case 'assessment':
      return 'Assessments';
    case 'course':
      return 'Courses';
    default:
      return cardview;
  }
};
  const [activeView, setActiveView] = useState('');  
  
  
  const [isMobile, setIsMobile]   = useState(window.innerWidth < 768);
  const [supportDrawerOpen, setSupportDrawerOpen] = useState(false);
  const hasFetchedRef = useRef(false);
  
  // ── PostHog: Track dashboard page view with params ──
  useEffect(() => {
    const examId = searchParams.get('examId');
    posthog.capture('dashboard_page_viewed', {
      initial_view: activeView || cardview,
      exam_id: examId || null,
      url_params: Object.fromEntries(searchParams.entries()),
    });
  }, []);

  // ── PostHog: Track navigation between views ──
  useEffect(() => {
    if (!activeView) return;
    posthog.capture('dashboard_section_navigated', {
      section: activeView,
      exam_id: searchParams.get('examId') || null,
    });
    // Reset scroll depth on view change
    maxScrollDepthRef.current = 0;
  }, [activeView]);

  // ── PostHog: Scroll depth tracking ──
  useEffect(() => {
    const handleScroll = (e) => {
      const el = e.target;
      if (!el || !el.scrollHeight) return;
      const depth = Math.round((el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100);
      if (depth > maxScrollDepthRef.current) {
        maxScrollDepthRef.current = depth;
      }
    };

    const sendScrollDepth = () => {
      if (maxScrollDepthRef.current > 0) {
        posthog.capture('dashboard_scroll_depth', {
          section: activeView,
          max_depth_percent: maxScrollDepthRef.current,
        });
      }
    };

    // Attach to the main content area
    const mainEl = document.querySelector('[data-scroll-track="dashboard-main"]');
    if (mainEl) {
      mainEl.addEventListener('scroll', handleScroll);
    }

    // Send scroll depth when user leaves or changes view
    return () => {
      sendScrollDepth();
      if (mainEl) {
        mainEl.removeEventListener('scroll', handleScroll);
      }
    };
  }, [activeView]);
  

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
 
  useEffect(() => {
    const fetchEssentialData = async () => {
      if (!userInfo?.id || hasFetchedRef.current) return;
      hasFetchedRef.current = true;
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(getAllcourseDetails('en')),
          dispatch(getCourseCompletion(userInfo.id)),
          dispatch(getSatDetails(userInfo.id)),
          dispatch(getNEETAssessment(userInfo.id)),
          dispatch(getOfferbaner()),
        ]);
      } catch {
        hasFetchedRef.current = false;
      } finally {
        setIsLoading(false);
      }
    };
    fetchEssentialData();
  }, [dispatch, userInfo?.id]);
 
  
   const hasSetInitialPreference = useRef(false);
 
//   useEffect(() => {
//   const preferredView = getInitialViewFromPreference(details);
//   if(location.state?.comingFrom === 'profile'){
//       setActiveView("Assessments")
//   }
//   else{
//       setActiveView(preferredView !== cardview ? preferredView : cardview)
//   }
//   localStorage.removeItem('restoreExamCode');
// ;
// }, [cardview,details]);
 
const hasManuallyNavigated = useRef(false);
 
const handleNavigate = (view) => {
  hasManuallyNavigated.current = true;
  posthog.capture('dashboard_nav_clicked', {
    from_section: activeView,
    to_section: view,
  });
  sessionStorage.removeItem('coursesSearch',"")
  dispatch(ComingFrom(view));
};
 
useEffect(() => {
setActiveView(cardview)
}, [cardview, details]);
 
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [activeView]);
  
 
  if (isLoading && !hasFetchedRef.current) return <DashboardSkeleton />;
 
  const renderContent = () => {
    switch (activeView) {
      case 'Dashboard':
      case 'MyLearning':
        return <DashboardView dataLoaded={!isLoading} />;
      case 'Courses':
        return <CoursesView />;
      case 'Assessments':
      case 'General Assessment':
      case 'NEET Assessment':
      case 'SAT/ACT':
        return <AssessmentsView />;
      case 'EBooks':
        return <EBooksView />;
      case 'Profile':
        return <ProfileView />;
      default:
        return <DashboardView dataLoaded={!isLoading} />;
    }
  };
 
  if (isMobile) {
    return (
      <div style={mobileStyles.root}>
        <main style={mobileStyles.content} data-scroll-track="dashboard-main">
          <Suspense fallback={<LoadingFallback />}>
            {renderContent()}
          </Suspense>
        </main>
        <BottomNav activeView={activeView} onNavigate={handleNavigate} onOpenSupport={() => setSupportDrawerOpen(true)} />
        <SupportDrawer open={supportDrawerOpen} onClose={() => setSupportDrawerOpen(false)} viewAllPath="/auth/support" />
      </div>
    );
  }
 
  return (
    <div style={desktopStyles.layout}>
      <Sidebar activeView={activeView} onNavigate={handleNavigate} onOpenSupport={() => setSupportDrawerOpen(true)} />
      <main style={desktopStyles.mainContent} data-scroll-track="dashboard-main">
        <Suspense fallback={<LoadingFallback />}>
          {renderContent()}
        </Suspense>
      </main>
      <SupportDrawer open={supportDrawerOpen} onClose={() => setSupportDrawerOpen(false)} viewAllPath="/auth/support" />
    </div>
  );
};
 
const desktopStyles = {
  layout: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    background: '#f9fafb',
  },
  mainContent: {
    flex: 1,
    minWidth: 0,
    height: '100vh',
    overflowY: 'auto',
  },
};
 
const sidebarStyles = {
  sidebar: {
    width: 236,
    minWidth: 236,
    flexShrink: 0,
    background: '#ffffff',
    borderRight: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 16,
    height: '100vh',
    overflowY: 'auto',
  },
  logoWrap: {
    height: 48,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 20,
    marginBottom: 8,
  },
  logoMark: {
    width: 32,
    height: 32,
    borderRadius: 8,
    // background: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: '8px 12px',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '9px 10px',
    borderRadius: 8,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    transition: 'background 0.15s ease',
  },
  navItemActive: {
    background: '#eff6ff',
  },
  navIcon: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  navLabel: {
    fontSize: 14,
    flex: 1,
    letterSpacing: '-0.01em',
  },
};
 
const mobileStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'hidden',
    background: '#f9fafb',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    paddingBottom: 64,
  },
};
 
const bottomNavStyles = {
  nav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 64,
    background: '#ffffff',
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    zIndex: 100,
    boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
    flex: 1,
    height: '100%',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '6px 0 4px',
    position: 'relative',
  },
  label: {
    fontSize: 10,
    letterSpacing: '0.01em',
    lineHeight: 1,
  },
  activeDot: {
    position: 'absolute',
    top: 6,
    width: 4,
    height: 4,
    borderRadius: '50%',
    background: '#2563eb',
  },
};
 
export default OptimizedDashboard;
 